import React from 'react';
import classes from "./Input.module.css";

const Input = ({text, name, width, height, type, onChange, value, required}) => {
  return (
    <input placeholder={text} required={required} name={name} onChange={onChange} value={value} id={name} className={classes.input} style={{width: width, height: height ? height : "fit-content"}} type={type} />
  );
};

export default Input;